<template>
  <div class="customer-card-box" v-if="showCard">
    <div class="box-cell">
      <button class="close" @click="show"></button>
      <img v-if="!hasLogin" alt="客户卡片" src="../images/customer-card-1.png">
      <img v-if="hasLogin" alt="客户卡片" src="../images/customer-card-2.png">
      <div class="card-info">
        <div v-if="hasLogin && customerData.daily.length > 0">
          <span class="card-info-title">日常对接</span>
          <div v-for="(item, index) in customerData.daily">
            <p class="info-body">{{item.role}}:&#09<span>{{item.name}}&#09</span><span>{{item.phone}}</span></p>
            <p style="margin-left: 12%"><a class="url-new-version" :href='`mailto:` + item.email'>{{item.email}}</a></p>
          </div>
        </div>
        <div style="margin-top: 8px">
          <span class="card-info-title">服务保障和监督投诉</span>
          <div v-for="(item, index) in customerData.service">
            <p class="info-body">{{item.role}}:&#09<span>{{item.name}}&#09</span><span>{{item.phone}}</span></p>
            <p style="margin-left: 12%"><a class="url-new-version" :href='`mailto:` + item.email'>{{item.email}}</a></p>
          </div>
        </div>
        <div style="margin-top: 8px">
          <span class="card-info-title">宝贵建议</span>
          <div v-for="(item, index) in customerData.recommend">
            <p class="info-body">&#09<span>{{item.name}}&#09</span><span>{{item.phone}}</span></p>
            <p style="margin-left: 12%"><a class="url-new-version" :href='`mailto:` + item.email'>{{item.email}}</a></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import util from "@/libs/util";

export default {
  name: "CustomerCard",
  props:{
    showCard: false,
    hasLogin: false,
    onClose: {
      type: Function,
      default: function () {},
    },
  },
  data () {
    return {
      customerData: {
        daily: [
          {
            role: "客服",
            name:"",
            phone: "",
            email: ""
          },
          {
            role: "销售",
            name: "",
            phone: "",
            email: ""
          },
        ],
        service: [
          {
            role: "客服",
            name:"孙小会",
            phone: "13127922603",
            email: "sunxiaohui@yazuishou.com",
          }
        ],
        recommend: [
          {
            role: "",
            name: "唐红斌",
            phone: "13761219091",
            email: "tanghongbin@yazuishou.com"
          },
        ],
      },
    }
  },
  methods:{
    show() {
      this.onClose();
    },
    getCustomerData() {
      util.customer_ajax_post(this, '/common/customer-card', {}, res => {
        if (res.data.success) {
          this.customerData = res.data.data
        }
      })
    }
  },
  created() {
    if (this.hasLogin) {
      this.getCustomerData()
    }
    if (sessionStorage.getItem('pathArray') === null) {
      let pathArray =[
        {path: '/order-tracking/index', firstIn: true},
        {path: '/home', firstIn: true},
        {path: '/order-booking/index', firstIn: true},
        {path: '/index'}
      ]
      sessionStorage.setItem('pathArray', JSON.stringify(pathArray))
    }
  },
  watch: {
    // $route(to, from) {
    //   let s = JSON.parse(sessionStorage.getItem('pathArray'))
    //   if (to.path === s[0].path && s[0].firstIn) {
    //     this.$parent.customerCard.show = true
    //     s[0].firstIn = false
    //   } else if(to.path === s[1].path && s[1].firstIn) {
    //     this.$parent.customerCard.show = true
    //     s[1].firstIn = false
    //   } else if (to.path === s[2].path && s[2].firstIn) {
    //     this.$parent.customerCard.show = true
    //     s[2].firstIn = false
    //   } else if (to.path === s[3].path){
    //     this.$parent.customerCard.show = true
    //   } else {
    //     this.$parent.customerCard.show = false
    //   }
    //   sessionStorage.setItem('pathArray', JSON.stringify(s))
    // },
  },
}
</script>

<style scoped>
  * {
    margin: 0;
    padding: 0;
  }
  .customer-card-box {
    position: absolute;
    top: 0%;
    right: 80px;
    height: 475px;
    overflow:hidden;
    filter:alpha(Opacity=0);
  }
  .box-cell {
    /*display: inline-block;*/
    /*position: relative;*/
  }
  .card-info {
    position:absolute;
    width: 231px;
    height: 300px;
    top: 22%;
    left: 20%;
    font-size: 12px;
  }
  .card-info-title{
    background: #E6FFFF;
    padding: 5px;
    border-radius: 3px;
    font-weight: bold;
    margin-top: 10%;
    font-size: 14px;
  }
  .info-body {
    margin-top: 5px;
    font-size: 12px;
  }
  .url-new-version{
    color: rgb(2, 202, 214);
  }
  .close {
    width: 25px;
    height: 25px;
    position:absolute;
    top: 9%;
    right: 15%;
    cursor: pointer;
    opacity: 0;
  }

</style>


// WEBPACK FOOTER //
// customer-card.vue?072ccbce